var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.574 2.346-13.137.052C13.05 2.419 8.7 6.803 8.722 12.19l.103 25.947c.021 5.387 4.405 9.736 9.792 9.715l13.138-.052c5.386-.021 9.736-4.406 9.715-9.792l-.103-25.947c-.022-5.387-4.406-9.737-9.793-9.715z",
    fill: "#FBB040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31.73 41.822-13.13.052a3.788 3.788 0 0 1-3.803-3.773l-.103-25.934a3.788 3.788 0 0 1 3.773-3.803l13.131-.052a3.788 3.788 0 0 1 3.803 3.773l.103 25.946a3.788 3.788 0 0 1-3.773 3.79zM18.473 9.595A2.582 2.582 0 0 0 15.9 12.18l.103 25.947a2.582 2.582 0 0 0 2.592 2.565l13.131-.052a2.582 2.582 0 0 0 2.572-2.586l-.103-25.966a2.582 2.582 0 0 0-2.592-2.546l-13.131.052z",
    fill: "#00A79E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34.798 12.876-19.488.077.004 1.194 19.489-.078-.005-1.193zM34.876 32.592l-19.488.077.004 1.193 19.489-.077-.005-1.193zM26.354 29.463 24.08 24.42l-5.053-2.202 11.504-4.282-4.177 11.526zm-4.17-7.162 2.77 1.252 1.273 2.76 2.311-6.322-6.354 2.31zM25.157 39.657a2.374 2.374 0 1 1-.02-4.748 2.374 2.374 0 0 1 .02 4.748zm-.014-3.542a1.174 1.174 0 1 0 .009 2.348 1.174 1.174 0 0 0-.01-2.348z",
    fill: "#00A79E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeExperience);
export default __webpack_public_path__ + "static/media/home-experience.99b699f996615e44810a20d00e80a6c5.svg";
export { ForwardRef as ReactComponent };